<template>
  <bk-page  class="check-in-page" pageType="navPage" :style="{backgroundImage: `url(https://static-global.boka.vc/mase/def/Def_Bg_C_CheckIn1.png)`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', overflow: 'auto'}" >
    <bk-view class="view-titleBox" >
        <bk-view  class="view-title" v-if="status == 1">
            <bk-image class="view-star" src="https://static-global.mase.cloud/mase/def/Def_Icon_Star.png"></bk-image>
            <bk-lang code="checkIn_checkInText"></bk-lang>
            {{rewardsNum}}
            <bk-lang code="checkIn_rewardsText"></bk-lang>
        </bk-view>
    </bk-view>
    <bk-view style="position: relative;">   
        <bk-image class="view-diamond" src='https://static-global.mase.cloud/mase/def/Def_Image_C_Diamond.png'></bk-image>

        <bk-view class="view-checkInContent" >
            <!--  -->
            <!-- <bk-view class="view-title" >
                <bk-lang code="checkIn_checkInText"></bk-lang>
                {{rewardsNum}}
                <bk-lang code="checkIn_rewardsText"></bk-lang>
            </bk-view> -->
            <!-- <bk-view v-else style="height: 24px;"></bk-view> -->
            <bk-view class="view-box">
                <bk-view class="view-right">
                    <bk-view class="view-search">
                        <bk-select v-model:value="type" width="110px" :data-list="typeList" @change="typeChange"/>
                        <!-- <bk-view class="view-value" v-if="type == 1">
                            <bk-view v-if="tempValue">{{tempValue}}</bk-view>
                            <bk-view v-else style="color: #ccc"><bk-lang code="checkIn_placeholder"></bk-lang></bk-view>
                        </bk-view> -->
                        <bk-input ref="focusRef" class="view-value" width="100%" lang-code_placeholder="checkIn_placeholder" v-model:value="tempValue"/>
                        <!-- <bk-view class="view-icon">
                            <bk-image src="https://static-global.boka.vc/mase/def/Def_Icon_CheckIn_Search.png"></bk-image>
                        </bk-view> -->
                    </bk-view>

                    <bk-view class="view-keyboard">
                        <bk-view 
                            class="bk-digit-item" 
                            v-for="(item,index) in keyboardList" :key="index" 
                            @click="handleItemClick(item)"
                        >
                            <bk-view v-if="item==='del'" class="bk-digit-item-del"><bk-image src="https://static-global.boka.vc/mase/def/Def_Icon_CheckIn_Del.png"></bk-image></bk-view>
                            <template v-else>{{item}}</template>
                        </bk-view>
                    </bk-view>
                </bk-view>
            </bk-view>

            <bk-view class="view-btn">
                <bk-button
                class="view-del-button"
                lang-code="checkIn_btn_checkInText"
                @click="saveClick()"
                />
            </bk-view>
            
            <bk-view class="view-hint">
                <bk-lang code="checkIn_hintText"></bk-lang>
            </bk-view>
        </bk-view>
    </bk-view>


    <transition name="rightFadeIn">
		<component 
			v-if="showPage"
			mode="component"
            :type="type"
            :tempValue="tempValue"
			:curShop="curShop" 
            :info="info"
			:is="showPage" 
			@close="showPage=''"
            @clear="clear"
            @getCheckIn="getCheckIn"
		>
		</component>
	</transition>

  </bk-page>

</template>

<script>

	import {baseReq,customerReq,shopReq} from '@/reqService/index';
    import checkInAdd from './checkInForm/checkInForm.vue';
    import signInSuccess from './signInSuccess/signInSuccess.vue'

	export default {
		name: 'checkIn',
		components: {checkInAdd,signInSuccess},
		data () {
			return {
				bkLoad: false,
                type: 1,
                typeList: [],
                tempValue: '',
                keyboardList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0', 'del'],
                showPage: '',
                rewardsNum: 0, // 奖品次数
                info: {}, // 签到成功数据
                curShop: {},
                status: 0,
                fullPath: ''
			};
		},
		computed:{
			navBarInfo (){
				let res = {
					backFlag: false,
				};
				return res;
			},
			
		},
		async created () {
            let orlanguage = navigator.language.toLowerCase();

			let language = this.$bk_Global.languageTypeList.find((item) => {
				let bcp47 = item.bcp47?.toLowerCase();
				if(orlanguage=== bcp47){
					return true;
				}
				return orlanguage.split('-')[1].toUpperCase() === bcp47.split('-')[1].toUpperCase();
			})?.key || 'en';

            this.$bk_switchLang(language);
            
            let {custId, id} = this.$route.query
            let {compId}  = this.$route.params
            this.curShop = this.$route.query

            this.fullPath = this.$route.fullPath
            this.$bk_saveDevelopLog({
				keyword: `签到`,
                actionData: {compId,id,fullPath:this.fullPath}
			});

            this.curShop = {
                custId: custId,
				compId: id || compId[0],
            }
            
            if (id || compId) {
                let res = await shopReq.requestGetShopDetailByCompId(this, id || compId[0]);
                this.$bk_saveDevelopLog({
                    keyword: `签到获取门店数据`,
                    actionData: {compId,id,res,fullPath:this.fullPath}
                });
                this.curShop = res || {
                    custId: custId,
                    compId: id || compId[0],
                }
            
            }
            this.requestPostCheckInDetails()

		},
        mounted () {
            this.typeList = [
                {label: this.$bk_lang['checkIn_phone'], key: 1},
                {label: this.$bk_lang['checkIn_email'], key: 2},
            ]
            this.$refs.focusRef.$el.children[0].children[0].focus();
        },
		methods: {
            getCheckIn (res) {
                this.info = {...res,rewardsNum: this.rewardsNum, status: this.status}
                this.showPage = 'signInSuccess'
            },
            async saveClick () {
                if (!this.tempValue) {
                    if (this.type == 1) {
                        this.$bk_message.error({ langCode:'checkInForm_verify_mobile'});
                    } else {
                        this.$bk_message.error({ langCode:'checkInForm_verify_email'});
                    }
                    return
                }
                this.requestPostCheckInDetails()
                let memberParams = {
                    custId: this.curShop.custId
                }
                if (this.type == 1) {
                    delete memberParams.email 
                    memberParams.mobile = this.tempValue
                } else {
                    delete memberParams.mobile 
                    memberParams.email = this.tempValue
                }
                let memberInfo = await customerReq.getMemberInfo(this,memberParams)
                this.$bk_saveDevelopLog({
                    keyword: `签到页面提交事件`,
                    actionData: {curShop: this.curShop,memberInfo,memberParams}
                });
                if (Object.keys(this.curShop).length == 0 || this.curShop.compId == '') {
                    this.$bk_message.error(this.$bk_lang['checkInForm_errorInfo']+`(${this.fullPath})`)
                    return
                }
                if (memberInfo && memberInfo.id) {
                    this.bkLoad = true; 
                    this.$bk_saveDevelopLog({
                        keyword: `老客户签到提交.`,
                        actionData: {curShop: this.curShop,memberInfo}
                    });
                    customerReq.memberCheckIn(this, {
                        custId: memberInfo.custId,
					    compId: memberInfo.compId,
                        memberId: memberInfo.id
                    }).then((res) => {
                        this.bkLoad = false;
                        if (res) {
                            this.getCheckIn(res)
                        } 
                    }).catch(() => {
                        this.bkLoad = false;
                    });
                } else {
                    this.showPage = 'checkInAdd'
                }

            },
            handleItemClick (key) {
                let {tempValue} = this
                tempValue = tempValue.toString();
                if (key !== 'del' && key != 'C') {
                    this.tempValue += key;
                    return
				}
                if (key == 'del') {
					this.tempValue = tempValue.substring(0, tempValue.length - 1);
					return;
				}
                if (key == 'C') {
					this.tempValue = '';
					return;
				}

            },
            async requestPostCheckInDetails () {
                let res = await baseReq.requestPostCheckInDetails(this,{custId: this.curShop.custId,compId: this.curShop.id,})
                if (res && res.length > 0) {
                    this.rewardsNum = res.find((item) => {
                        return item.code == 'CI002';
                    }).value;
                    this.status = res.find((item) => {
                        return item.code == 'CI001';
                    }).status;
                } 
            },
            typeChange () {
                if (this.type != 1) {
                    this.$nextTick(() => {
						this.$refs.focusRef.$el.children[0].children[0].focus();
					});
                }

            },
            clear () {
                this.tempValue = ''
            },
		
		}
	};
</script>

<style scoped lang="less">
.check-in-page {
    .view-titleBox {
        z-index: 9;
        height: 83px;
        text-align: center;
        > .view-title {
            margin-top: 50px;
            background: rgba(24,6,60,0.5);
            height: 32px;
            display: inline-block;
            font-family: PingFang SC, PingFang SC;
            font-size: 13px;
            padding: 0 20px 0 20px;
            line-height: 32px;
            text-align: center;
            border-radius: 32px;
            color: #fff;
            backdrop-filter: blur(6px);
            -webkit-backdrop-filter: blur(10px);
            > .view-star {
                width: 24px;
                height: 25px;
                margin-top: 3px;
                margin-right: 4px;
            }
        }
    }
    .view-diamond {
        position: absolute;
        right: 0px;
        top: -98px;
        width: 110px;
        height: 132px;
    }
    .view-checkInContent {
        // position: relative;
        overflow: auto;
        padding: 16px;
        margin: 12px 16px 16px;
        background: rgba(237,242,254,0.61);
        border: 2px solid #FFFFFF;
        backdrop-filter: blur(10px);
        border-radius: 12px 12px 12px 12px;
        // > .view-title {
        //     font-family: PingFang SC, PingFang SC;
        //     font-weight: 600;
        //     font-size: 16px;
        //     height: 64px;
        //     line-height: 64px;
        //     margin: 0 auto;
        //     text-align: center;
        //     background: #fcdfc8 url("https://static-global.boka.vc/mase/def/Def_Bg_CheckIn_Title.png") right center / 500px no-repeat;
        //     color: #FF971E;
        // }
        > .view-box {
            padding: 16px 0px;
            display: flex;
            
            > .view-right {
                flex: 1;
                > .view-search {
                    border: 1px solid #D4DDF8;
                    display: flex;
                    border-radius: 6px 6px 6px 6px;
                    background: #fff;
                    height: 48px;
                    line-height: 48px;
                    margin-bottom: 8px;
                    :deep(.bk-select) > .view-value,
                    :deep(.bk-input) > .view-input {
                        border: none;
                        border-radius: 5px 0 0 5px;
                    }
                    .bk-input {
                        border-radius: 0;
                    }
                    :deep(.bk-select) > .view-value > .view-select > .ant-select-selector > .ant-select-selection-item {
                        line-height: 28px;
                    }
                    :deep(.bk-select) > .view-value > .view-select > .ant-select-selector  {
                        height: 46px;
                        padding-left: 24px;
                        
                    }
                    :deep(.bk-input) > .view-input > input {
                        padding: 0;
                        font-size: 18px;
                        line-height: 20px;
                    }
                    :deep(.bk-input) > .view-input > .view-clear {
                        display: none;
                    }
                    > .view-value {
                        flex: 1;
                        // max-width: 140px;
                        flex: 1;
                        border-left: 1px solid #D4DDF8;
                        margin: 10px 0 12px 0px;
                        padding-left: 16px;
                        line-height: 22px;
                        font-size: 18px;
                        overflow: auto;
                    }
                    > .view-icon {
                        padding: 16px 20px;
                        .bk-image {
                            width: 16px;
                            height: 16px;
                        }
                    }
                }
                > .view-keyboard {
                    display: flex;
                    flex-wrap: wrap;
                    > .bk-digit-item {
                        background: #FFFFFF;
                        box-shadow: 0px 1px 2px -1px rgba(0,0,0,0.25);
                        border-radius: 6px 6px 6px 6px;
                        border: 1px solid #D4DDF8;
                        font-family: MiSans, MiSans;
                        width: 32%;
                        height: 68px;
                        line-height: 60px;
                        font-weight: 600;
                        text-align: center;
                        margin-right: 2%;
                        margin-top: 2%;
                        font-size: 28px;
                        &:nth-child(3n) {
                           margin-right: 0;  
                        }
                        &:hover {
                            background: #D4DDF8;
                        }
                    }

                    .bk-digit-item-del {
                        > .bk-image {
                            width: 24px;
                            margin-top: 22px;
                        }
                    }
                }
            }
        }

        > .view-btn {
            text-align: center;
            margin-top: 12px;
            margin-bottom: 28px;
            > .bk-button {
                width: 304px;
                height: 48px;
                font-size: 16px;
                border-radius: 48px;
                background: linear-gradient( 315deg, #70DCFF 0%, #4D85FF 18%, #6976FF 63%, #9889F8 100%);
                border: none;
            }
        }

        > .view-hint {
            margin: 0 auto;
            width: 275px;
            text-align: center;
        }
    }
}

</style>